import { FC, useContext } from "react";
import {
  Typography,
  Box,
  useMediaQuery,
  Button,
  makeStyles,
  Container,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import { CongratsProps } from "../../interfaces";
import congrat from "../../assets/images/congrat.svg";
import { useHistory } from "react-router";
import SubscriptionContext from "../../store/Subscription/SubscriptionContext";

const useStyles = makeStyles((theme) => ({
  congrats: {
    "& br": {
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
  },
  longbtn: {
    paddingRight: theme.spacing(6),
    paddingLeft: theme.spacing(6),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      minWidth: "100%",
    },
  },
}));
const CongratComponent: FC<CongratsProps> = ({ invest, allocatedTickets }) => {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  const projectName = localStorage.getItem("projectName");
  const totalTickets  = allocatedTickets ? allocatedTickets : 0;
  return (
    <>
      <Container fixed>
        <Box
          mt={isActive ? 3 : 5}
          ml={isActive ? 0 : 0}
          display="flex"
          flexDirection="column"
          alignItems="center"
          component="section"
          className={classes.congrats}
        >
          <Box>
            <img src={congrat} alt="gains" className="img-fluid" />
          </Box>
          <Box mt={4} mb={isActive ? 1 : 2}>
            {invest ? (
              <Typography variant="h2" color="secondary">
                Congrats...{" "}
                <Typography variant="h2" color="primary" component="span">
                  
                </Typography>
              </Typography>
            ) : (
              <Typography variant="h2" color="primary">
                Congrats
              </Typography>
            )}
          </Box>
          {invest ? (
            <Typography variant="body1" align="center" className="body-color">
              Keep track of your investment on your dashboard, accessible on{" "}
              <br />
              <Typography
                component="span"
                color="primary"
                className="fw-bold text-br"
              >
                “My Portfolio”.
              </Typography>
            </Typography>
          ) : (
            <Typography variant="body1" align="center" className="body-color">
              Congrats, your submission is completed with{" "}
              <Typography
                component="span"
                color="primary"
                className="fw-bold text-br"
              >
                {""} {totalTickets} tickets! <br />
              </Typography>{" "}
              You will receive an email within{" "}
              <Typography component="span" color="primary" className="fw-bold">
                48 hours{" "}.
              </Typography >{" "}
              {/* for 
                <Typography component="span" color="primary" className="fw-bold">{" "}
                {projectName}.
                </Typography> */}
            </Typography>
          )}
        </Box>
        <Box mt={isActive ? 4 : 5} mb={isActive ? 3 : 10} textAlign="center">
          <Button
            variant="outlined"
            color="secondary"
            className={classes.longbtn}
            onClick={() => history.push("/deals")}
          >
            back to main menu
          </Button>
        </Box>
      </Container>
    </>
  );
};

export default CongratComponent;
